// Timeline date helpers. Dates are stored as "YYYY", "YYYY-MM" or "YYYY-MM-DD"
// strings; the timeline works at month granularity (monthIndex = year*12 + m-1).

export function dateToMonth(s) {
  if (!s) return null;
  const m = String(s).match(/^(\d{4})(?:-(\d{1,2}))?/);
  if (!m) return null;
  return Number(m[1]) * 12 + (m[2] ? Number(m[2]) - 1 : 0);
}

// Date fields take a year, a year and month, or a full date — "2026",
// "2026-4" / "2026-04", "2026-04-15" (also with / or . between) — and store
// the canonical "YYYY" / "YYYY-MM" / "YYYY-MM-DD". Returns null for an empty
// field, undefined for anything that isn't a real date.
export const DATE_PLACEHOLDER = 'YYYY-MM-DD';
export const DATE_HINT = 'A year, a year and month, or a full date — e.g. 2026, 2026-04 or 2026-04-15';

export function normalizeDate(input) {
  const s = String(input ?? '').trim();
  if (!s) return null;
  const m = s.match(/^(\d{4})(?:[-/.](\d{1,2})(?:[-/.](\d{1,2}))?)?$/);
  if (!m) return undefined;
  const [, y, mo, d] = m;
  if (!mo) return y;
  const month = Number(mo);
  if (month < 1 || month > 12) return undefined;
  const mm = String(month).padStart(2, '0');
  if (!d) return `${y}-${mm}`;
  const day = Number(d);
  const daysInMonth = new Date(Date.UTC(Number(y), month, 0)).getUTCDate();
  if (day < 1 || day > daysInMonth) return undefined;
  return `${y}-${mm}-${String(day).padStart(2, '0')}`;
}

export function monthLabel(month) {
  if (month == null) return '';
  const y = Math.floor(month / 12);
  const m = (month % 12) + 1;
  return `${y}-${String(m).padStart(2, '0')}`;
}

export function todayMonth() {
  // Date is unavailable in some sandboxes; guard.
  try { const d = new Date(); return d.getFullYear() * 12 + d.getMonth(); } catch (e) { return null; }
}

// An element is visible at a given month if it has been added by then and not
// yet removed.
export function visibleAtMonth(el, month) {
  if (month == null) return true;
  const added = dateToMonth(el.data?.addedDate);
  const removed = dateToMonth(el.data?.removedDate);
  if (added != null && added > month) return false;
  if (removed != null && removed <= month) return false;
  return true;
}

// Min/max month across all element add/remove dates, or null if none have dates.
export function dateRange(elements) {
  let min = Infinity; let max = -Infinity;
  for (const el of elements) {
    for (const key of ['addedDate', 'removedDate']) {
      const m = dateToMonth(el.data?.[key]);
      if (m != null) { min = Math.min(min, m); max = Math.max(max, m); }
    }
  }
  if (!isFinite(min)) return null;
  return { min, max: Math.max(max, min) };
}
